import { render } from "./TecRussia.vue?vue&type=template&id=44a39944&scoped=true"
import script from "./TecRussia.vue?vue&type=script&lang=js"
export * from "./TecRussia.vue?vue&type=script&lang=js"

import "./TecRussia.vue?vue&type=style&index=0&id=44a39944&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a39944"]])

export default __exports__